
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function VideoLearningPreview() {
  const benefits = [
    "Curated educational videos matching your learning needs",
    "Personalized video recommendations based on your weak areas",
    "Interactive video learning with embedded quizzes",
    "Adjustable playback speed based on your mastery level",
    "Topic-wise organized video content for easy navigation",
    "Save key segments for quick revision before exams"
  ];
  
  const screenshots = [
    {
      url: "/placeholder.svg",
      caption: "Educational Video Platform - Learn visually with expert content"
    },
    {
      url: "/placeholder.svg",
      caption: "Video Learning Dashboard - Personalized video recommendations"
    }
  ];

  return (
    <FeatureShowcase
      title="Personalized Video Learning"
      description="Master concepts through visual learning with our curated educational videos."
      featureName="Video Learning"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
